import { PermissionCode, type AuthUser } from '@gb-ticket/shared-types';

import { hasPermission } from '@/platform/auth/permissions';

export function canAccessLeaveAdmin(user: AuthUser | null | undefined): boolean {
  return (
    hasPermission(user, PermissionCode.LEAVE_POLICY_MANAGE) ||
    hasPermission(user, PermissionCode.LEAVE_BALANCES_ADJUST) ||
    hasPermission(user, PermissionCode.LEAVE_REPORTS_EXPORT)
  );
}
